/* istanbul ignore file */
export class RichTextGridColumnDictionary {
    [key: string]: RichTextGridFieldEditor;
}

export class RichTextGridFieldEditor {
    inEditMode = false;
}
